import { Edit } from "react-admin";
import * as React from "react";
import { FaqCreateForm } from "./FaqCreate";

export const FaqEdit = () => (
  <Edit>
    <FaqCreateForm />
  </Edit>
);
